import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import TermAttendanceStatusService from "../../src/Services/TermAttendanceStatus.service";
import LookupGeneric from "./lookupGeneric";
const TermAttendanceStatusLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'number[]'.
            return TermAttendanceStatusService.findByIds(ids);
        },
        fetchOptions: (query) => {
            return TermAttendanceStatusService.search({
                // @ts-expect-error - TS2345 - Argument of type '{ query: string; }' is not assignable to parameter of type 'TermAttendanceStatusSearchArgs'.
                query,
            }).then(({ data }) => data);
        },
        optionRenderer: function optionRenderer(termAttendanceStatus) {
            return _jsx("span", { children: termAttendanceStatus.name });
        },
    });
};
export default TermAttendanceStatusLookup;
